import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { forwardRef } from 'react';
import defaultStyles from './styles/Typography.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { omit } from '../../utils/omit.js';

const Typography = /*#__PURE__*/forwardRef(({
  tag = 'span',
  variant = 'body',
  weight = 'regular',
  align,
  noWrap = false,
  children,
  dataTestId,
  theme,
  component,
  inverted = false,
  ...rest
}, ref) => {
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const Component = component || tag;
  const variantClasses = {
    [styles.pageheading]: variant === 'pageheading',
    [styles.heading]: variant === 'heading',
    [styles.subheading]: variant === 'subheading',
    [styles.body]: variant === 'body',
    [styles.bodyLarge]: variant === 'bodyLarge',
    [styles.caption]: variant === 'caption',
    [styles.label]: variant === 'label',
    [styles.button]: variant === 'button',
    [styles.display_xl]: variant === 'displayExtraLarge',
    [styles.display_l]: variant === 'displayLarge',
    [styles.display_m]: variant === 'displayMedium',
    [styles.display_sm]: variant === 'displaySmall',
    [styles.display_xs]: variant === 'displayExtraSmall',
    [styles.error]: variant === 'error'
  };
  const tagClasses = {
    [styles.bold]: tag === 'b' || tag === 'strong',
    [styles.italic]: tag === 'i' || tag === 'em'
  };
  const weightClasses = {
    [styles.regular]: weight === 'regular',
    [styles.bold]: weight === 'bold',
    [styles.medium]: weight === 'medium',
    [styles.light]: weight === 'light'
  };
  const alignClasses = {
    [styles.center]: align === 'center',
    [styles.inherit]: align === 'inherit',
    [styles.justify]: align === 'justify',
    [styles.left]: align === 'left',
    [styles.right]: align === 'right'
  };
  const elementProps = {
    className: clsx(styles.root, noWrap && styles.no_wrap, variantClasses, tagClasses, weightClasses, alignClasses, {
      [styles.inverted]: inverted
    }),
    'data-test-id': dataTestId || null
  };
  return /*#__PURE__*/jsx(Component, {
    ref: ref,
    ...elementProps,
    ...omit(rest, ['theme']),
    children: children
  });
});

export { Typography };
